<template>
  <section class="rfps-rfps-list d-flex flex-column">
    <fixed-header
      title="Quote Request List"
      :records="pageInfo.totalItems"
      hideBackBtn
    />
    <div class="card h-50">
      <!-- <div class="card-header">
        <i class="fa fa-align-justify"></i>
        RFP List
        <records-count :total="pageInfo.totalItems" />
      </div> -->

      <div class="card-body d-flex flex-column">
        <div class="d-flex justify-content-start align-items-end mb-2">
          <b-form-group label="Status" class="mr-2">
            <b-form-select v-model="filtersObj.statusId" @change="onSearch">
              <option :value="null">ALL</option>
              <option v-for="(status) in sortSelect(rfpStatuses)" :key="status.id" :value="status.id">{{status.name}}</option>
            </b-form-select>
          </b-form-group>
          <date-range-picker :dateFrom="filtersObj.dateFrom" :dateTo="filtersObj.dateTo" @handleSearch="onSearch"></date-range-picker>
          <div class="clear-filter-button-container">
            <b-button size="sm" @click="onClear">Clear filters</b-button>
          </div>
        </div>
        <grid-component
          isResizable
          isReorderable
          isSortable
          :canEdit="checkClaim(CAN_EDIT_SOURCING_CENTER)"
          :canDelete="checkClaim(CAN_DELETE_SOURCING_CENTER)"
          :gridId="gridId"
          :pageable="pageable"
          :skip="pageInfo.pageSize * (pageInfo.pageNumber - 1)"
          :take="pageInfo.pageSize"
          :itemData="itemData"
          :pageSizes="pageInfo.pageSize"
          :totalItems="pageInfo.totalItems"
          :fields="fields"
          :sortBy="pageInfo.sortBy"
          :sortOrder="pageInfo.sortOrder"
          :sortMethod="sortRfps"
          :onEdit="pushToDetails"
          :onDelete="onDelete"
          :handleRowClick="onSelectChange"
          :styleCustom="'height: 250px'"
          @getData="onGetData"
          :isTblLoader="tblLoader"
        />
      </div>
    </div>

    <!-- <tabs v-if="selectedRfpId" /> -->
    <b-card>
      <b-tabs class="d-flex flex-column h-50">
        <b-tab title="Selected Parts">
          <selected-parts rfpHome />
        </b-tab>
        <b-tab title="Selected Vendors">
          <selected-vendors rfpHome />
        </b-tab>
      </b-tabs>
    </b-card>
  </section>
</template>

<script>
import debounce from 'lodash/debounce';
import {  mapGetters, mapActions, mapMutations } from 'vuex';

import { date, dateTime } from '@/shared/filters';
import { SEARCH_DEBOUNCE_TIME, GRID_PAGE_SIZES, SORT_ORDER, GRID_ID } from '@/shared/constants';
import { prepareColumnsData } from '@/shared/helpers';
import DateFilters from '@/shared/components/DateFilters';
import GridSettings from '@/shared/components/GridSettings';
import GridComponent from '@/shared/components/GridComponent';
import FixedHeader from '@/shared/components/FixedHeader/indexNew';
import DateRangePicker from '@/shared/components/DateRangePicker/IndexNew';
import SelectedParts from '@/pages/Rfp/components/RfpDetails/components/SelectedParts';
import SelectedVendors from '@/pages/Rfp/components/RfpDetails/components/SelectedVendors';

import Tabs from './components/Tabs';
import fields from './fields';

export default {
  components: {
    Tabs,
    DateFilters,
    GridSettings,
    GridComponent,
    FixedHeader,
    DateRangePicker,
    SelectedParts,
    SelectedVendors,
  },
  data: () => ({
    prepareColumnsData,
    fields,
    date,
    dateTime,
    pageable: {
      pageSizes: GRID_PAGE_SIZES,
    },
    gridId: GRID_ID.RFP,
    selectedRowItemId: 0,
    filterPageName: 'RfpListPage'
  }),
  metaInfo: () => ({
    title: 'RFP',
  }),
  computed: {
    ...mapGetters('rfps', {rfps: 'gridList'}),
    ...mapGetters('rfps', [
      // 'rfps',
      'pageInfo',
      'filters',
      'lastOpenedId',
      'tblLoader'
    ]),
    ...mapGetters('account', ['gridSettingsById']),
    ...mapGetters('lookup', ['rfpStatuses']),
    gridSettings() {
      return this.gridSettingsById(this.gridId);
    },
    itemData() {
      return this.rfps.map((rfp) => ({ ...rfp, selected: rfp.id === this.selectedRowItemId }));
    },
    filtersObj() {
      return this.filters[this.filterPageName] || {}
    },
  },
  watch: {
    async rfps() {
      this.selectedRowItemId = await this.setSelectedRowId(this.rfps,this.selectedRowItemId,this.lastOpenedId);
      if(this.rfps.length > 0  && this.selectedRowItemId){
        /*this.setSelectedRfpId(this.selectedRowItemId);*/
        this.setItem({ resource:'selectedRfpId', payload: this.selectedRowItemId });
      } else {
        /*this.setSelectedRfpId(null);*/
        this.setItem({ resource:'selectedRfpId', payload: null });
      }
      /*if(this.rfps.length > 0 && this.selectedRowItemId === 0 && !this.lastOpenedId){
        this.selectedRowItemId = this.rfps[0].id;
        const { id, detailsVisible } = this.rfps[0];
        this.selectRfp({ id, isChecked: !detailsVisible });
      }*/
    },
  },
  methods: {
    // ...mapMutations('rfps', ['setLastOpenedId','setSelectedRfpId']),
    ...mapMutations('rfps', ['setItem']),
    ...mapActions('rfps', [
      'getRfps',
      'sortRfps',
      'getPage',
      'searchRfps',
      'selectRfp',
      'removeRfp',
    ]),
    ...mapActions('account', ['saveGridSettings']),
    async onGetData(params) {
      await this.getRfps(params);
    },
    pushToDetails(row) {
      /*this.setLastOpenedId(row.id);*/
      this.setItem({ resource:'lastOpenedId', payload: row.id });

      this.$router.push({
        name: 'rfp.details',
        params: { id: row.id },
      });
    },
    async onDelete(rfp) {
      const deleteConfirmed = await this.openConfirmBox({message: `Are you sure you want to delete RFP #${rfp.id}?`});
      if (deleteConfirmed) {
        await this.removeRfp(rfp.id);
        this.getRfps({});
      }
    },
    onSelectChange(row) {
      this.selectedRowItemId = row.dataItem.id;
      const { id, detailsVisible } = row.dataItem;
      this.selectRfp({ id, isChecked: !detailsVisible });
    },

    onSearch: debounce(function(data= false) {
      if(typeof data === 'object') { Object.assign(this.filtersObj,data) }
      console.log({'filters':this.filtersObj,page:this.filterPageName});
      this.searchRfps({'filters':this.filtersObj,page:this.filterPageName});
    }, SEARCH_DEBOUNCE_TIME),
    onClear(callSearch=true) {
      this.clearObject(this.filtersObj);
      if (callSearch) {
        this.searchRfps({'filters':this.filtersObj,'page':this.filterPageName});
      }
    },
    onRangeChange(range) {
      this.setDateRange(range);
    },
  },
  async mounted() {
    this.setItem({ resource:'filterPage', payload: this.filterPageName });
    if('clear' in this.$route.query) {
      this.pageInfo.pageNumber=1;
      this.onClear(false)
      this.clearRoute();
    }else{
      if(this.lastOpenedId) {
        this.selectedRowItemId = this.lastOpenedId;
      }

      this.setItem({ resource: 'pageInfo', payload: {...this.pageInfo, ...this.gridSettings.sort, ...this.gridSettings.pageSize} });
      await this.getRfps({});
    }
  },
  beforeDestroy() {
    this.selectRfp({ id: null, isChecked: false });
  },
};
</script>

<style lang="scss">
@import '@/assets/scss/_colors.scss';
.rfps-rfps-list {
  .filters {
    margin-bottom: 5px;
  }
  .search {
    margin-bottom: 1.25rem;
  }
  .highlight {
    background: $rowSelection !important;
  }
  .clear-filter-button-container {
    margin-top: 12px;
    text-align: right;
  }
  &--grid-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  
}
</style>
